/**
 * Shared FAQ section fetch (Section Rendering API) + inject.
 * Used by: (1) designer page /apps/designer via window.TAFSEEL_DESIGNER_FAQ
 *           (2) optional: sections/page-faqs embed (inline can call attachFromDataAttrs)
 */
(function () {
  'use strict';

  function looksLikeSectionHtml(s) {
    if (typeof s !== 'string') return false;
    var t = s.trim();
    if (t.length < 8) return false;
    if (/<[a-z!?]/i.test(t)) return true;
    if (t.indexOf('shopify-section') !== -1) return true;
    if (t.indexOf('&lt;') !== -1) return true;
    return false;
  }

  function isLikelyTimestampString(s) {
    if (typeof s !== 'string') return false;
    var t = s.trim();
    if (t.length < 8 || t.length > 48) return false;
    if (/^\d{4}-\d{2}-\d{2}/.test(t)) return true;
    if (/^\d{10,13}$/.test(t)) return true;
    return false;
  }

  function skipMetadataKey(k) {
    var low = String(k).toLowerCase();
    if (low === 'errors' || low === 'error' || low === 'message' || low === 'status') return true;
    if (low.indexOf('time') !== -1 || low.indexOf('date') !== -1) return true;
    return false;
  }

  function normalizeSectionPayload(value, depth) {
    if (value == null || value === false) return '';
    if (typeof value === 'string') {
      if (value === 'null' || value === 'undefined') return '';
      if (isLikelyTimestampString(value)) return '';
      return value;
    }
    if (typeof value !== 'object') return '';
    var d = depth || 0;
    if (d > 6) return '';
    if (typeof value.html === 'string' && !isLikelyTimestampString(value.html)) return value.html;
    if (typeof value.content === 'string' && !isLikelyTimestampString(value.content)) return value.content;
    if (typeof value.markup === 'string' && !isLikelyTimestampString(value.markup)) return value.markup;
    if (value.sections && typeof value.sections === 'object') {
      var nested = normalizeSectionPayload(value.sections, d + 1);
      if (nested && !isLikelyTimestampString(nested)) return nested;
    }
    for (var k in value) {
      if (!Object.prototype.hasOwnProperty.call(value, k)) continue;
      if (skipMetadataKey(k)) continue;
      var inner = normalizeSectionPayload(value[k], d + 1);
      if (inner && !isLikelyTimestampString(inner) && looksLikeSectionHtml(inner)) return inner;
    }
    return '';
  }

  function unwrapSectionsJson(json, sectionId) {
    if (!json || typeof json !== 'object') return json;
    if (sectionId && json[sectionId] != null) return json;
    if (json.sections && typeof json.sections === 'object' && !Array.isArray(json.sections)) {
      return json.sections;
    }
    return json;
  }

  function fetchSectionsJson(path, sectionId) {
    var sep = path.indexOf('?') >= 0 ? '&' : '?';
    return fetch(path + sep + 'sections=' + encodeURIComponent(sectionId), {
      credentials: 'same-origin',
      headers: { 'X-Requested-With': 'XMLHttpRequest', Accept: 'application/json' },
    }).then(function (r) {
      if (!r.ok) throw new Error('sections HTTP ' + r.status);
      return r.json();
    });
  }

  function fetchSectionIdHtml(path, sectionId) {
    var sep = path.indexOf('?') >= 0 ? '&' : '?';
    return fetch(path + sep + 'section_id=' + encodeURIComponent(sectionId), {
      credentials: 'same-origin',
      headers: { 'X-Requested-With': 'XMLHttpRequest', Accept: 'text/html,*/*' },
    }).then(function (r) {
      if (!r.ok) throw new Error('section_id HTTP ' + r.status);
      return r.text();
    });
  }

  function pickHtmlFromJson(json, sectionId) {
    if (!json || typeof json !== 'object') return '';
    json = unwrapSectionsJson(json, sectionId);
    var html = normalizeSectionPayload(json[sectionId], 0);
    if (html && looksLikeSectionHtml(html)) return html;
    var keys = Object.keys(json);
    for (var i = 0; i < keys.length; i++) {
      var k = keys[i];
      if (skipMetadataKey(k)) continue;
      if (sectionId && k !== sectionId && k.indexOf('template--') !== 0 && k.indexOf('__') === -1) continue;
      var v = normalizeSectionPayload(json[k], 0);
      if (v && looksLikeSectionHtml(v)) return v;
    }
    return '';
  }

  function withLocalePrefix(path, localeRoot) {
    if (!path) return '';
    if (/^https?:\/\//i.test(path)) return path;
    var lr = (localeRoot || '/').replace(/\/?$/, '');
    if (!lr || lr === '' || lr === '/') return path;
    if (path.indexOf(lr + '/') === 0 || path === lr) return path;
    if (path.charAt(0) === '/') return lr + path;
    return lr + '/' + path;
  }

  function attachFromDataAttrs(wrap) {
    if (!wrap || wrap.getAttribute('data-tafseel-faq-embed-done') === '1') return;
    var rawPath = (wrap.getAttribute('data-faq-path') || '').trim();
    var localeRoot = (wrap.getAttribute('data-locale-root') || '/').trim() || '/';
    var fallbackHref = (wrap.getAttribute('data-faq-fallback-href') || rawPath).trim();
    var sid = (wrap.getAttribute('data-section-instance-id') || '').trim();
    sid = sid.replace(/^shopify-section-/i, '').replace(/^["']|["']$/g, '').trim();
    var loadEl = wrap.querySelector('[data-role="loading"]');
    var tgt = wrap.querySelector('[data-role="target"]');
    var debug = wrap.getAttribute('data-embed-debug') === '1';

    function fail(msg) {
      wrap.removeAttribute('aria-busy');
      if (loadEl) loadEl.remove();
      if (!tgt) return;
      var esc = (fallbackHref || '').replace(/&/g, '&amp;').replace(/"/g, '&quot;');
      var detail = debug && msg ? '<br><small>' + String(msg).replace(/</g, '&lt;') + '</small>' : '';
      tgt.innerHTML =
        '<p class="rte"><a href="' + esc + '">' + (window.TAFSEEL_DESIGNER_FAQ_LINK_TEXT || 'View FAQs') + '</a>' + detail + '</p>';
    }

    function injectHtml(html) {
      var str = normalizeSectionPayload(html, 0);
      if (!str || String(str).trim() === '' || !looksLikeSectionHtml(str)) {
        throw new Error('empty or non-HTML section');
      }
      if (loadEl) loadEl.remove();
      tgt.innerHTML = str;
      wrap.removeAttribute('aria-busy');
      wrap.setAttribute('data-tafseel-faq-embed-done', '1');
      tgt.querySelectorAll('script').forEach(function (old) {
        var s = document.createElement('script');
        for (var i = 0; i < old.attributes.length; i++) {
          var a = old.attributes[i];
          s.setAttribute(a.name, a.value);
        }
        s.textContent = old.textContent;
        old.parentNode.replaceChild(s, old);
      });
    }

    if (!rawPath || !sid || !tgt) {
      fail('Missing FAQ page path or Section ID.');
      return;
    }

    var path = withLocalePrefix(rawPath, localeRoot);
    fetchSectionsJson(path, sid)
      .then(function (json) {
        var html = pickHtmlFromJson(json, sid);
        if (typeof html === 'string' && html.trim() !== '') return html;
        throw new Error('sections returned empty (wrong Section ID?)');
      })
      .catch(function (e1) {
        return fetchSectionIdHtml(path, sid).catch(function (e2) {
          throw new Error((e1 && e1.message) + ' | ' + (e2 && e2.message));
        });
      })
      .then(function (html) {
        injectHtml(html);
      })
      .catch(function (err) {
        fail(err && err.message ? err.message : 'fetch failed');
      });
  }

  function initDesignerFaqEmbed() {
    var cfg = window.TAFSEEL_DESIGNER_FAQ;
    if (!cfg || !cfg.pagePath || !cfg.sectionId) return;
    function attempt() {
      if (document.getElementById('tafseel-designer-faq-embed')) return true;
      var notice = document.getElementById('designOwnershipNotice');
      if (!notice) return false;
      var wrap = document.createElement('div');
      wrap.id = 'tafseel-designer-faq-embed';
      wrap.setAttribute('role', 'region');
      wrap.setAttribute('aria-live', 'polite');
      wrap.setAttribute('aria-busy', 'true');
      wrap.style.cssText =
        'width:100%;max-width:960px;margin:16px auto 0;box-sizing:border-box;padding:0 12px;';
      wrap.setAttribute('data-faq-path', cfg.pagePath);
      wrap.setAttribute('data-locale-root', cfg.localeRoot || '/');
      wrap.setAttribute('data-faq-fallback-href', cfg.fallbackHref || cfg.pagePath);
      wrap.setAttribute('data-section-instance-id', cfg.sectionId);
      if (cfg.debug) wrap.setAttribute('data-embed-debug', '1');
      var tgt = document.createElement('div');
      tgt.setAttribute('data-role', 'target');
      var loadEl = document.createElement('p');
      loadEl.setAttribute('data-role', 'loading');
      loadEl.className = 'rte';
      loadEl.style.cssText = 'margin:8px 0;text-align:center;opacity:0.8;';
      loadEl.textContent = cfg.loadingText || '…';
      wrap.appendChild(tgt);
      wrap.appendChild(loadEl);
      notice.insertAdjacentElement('afterend', wrap);
      attachFromDataAttrs(wrap);
      return true;
    }
    if (attempt()) return;
    var tries = 0;
    var iv = setInterval(function () {
      tries++;
      if (attempt() || tries > 240) clearInterval(iv);
    }, 500);
  }

  window.TafseelFaqSectionEmbed = { attachFromDataAttrs: attachFromDataAttrs };

  function onReady(fn) {
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', fn);
    else fn();
  }

  onReady(function () {
    if ((window.location.pathname || '').indexOf('/apps/designer') === -1) return;
    if (!window.TAFSEEL_DESIGNER_FAQ) return;
    initDesignerFaqEmbed();
  });
})();
